module.exports = "/images/social-linkedin-light.png?7cb5dd0ea780a22f1b2dd8ff312eec18";